// extracted by mini-css-extract-plugin
export default {"chat-widget":"ChatWidget_chat-widget__YpPhn","chat-widget-preview":"ChatWidget_chat-widget-preview__O2ODh","chat-widget__wrapper":"ChatWidget_chat-widget__wrapper__xOD-v"};